import React, { Fragment, useContext, useEffect, useState } from "react";

import Button from "../Components/Base/Button";
import { LoadingContext, MainContext, ProfileContext } from "../Context";
import {
  TransactionPostCart,
  TransactionRulesGet,
} from "../Services/Transactions";

import { CartDetailTypeEnum, RuleType } from "../Structures";
import { formatPrice, handleCopyText } from "../Utils";
import { PageHeader } from "../Components/Common";
import { Toast } from "../Utils";
import { Empty } from "../Components/Base";

const Rules = () => {
  const { setting } = useContext(MainContext);
  const { profile } = useContext(ProfileContext);
  const { loading, setLoading } = useContext(LoadingContext);

  // ===========================================================================

  const [rules, setRules] = useState<RuleType[]>([]);

  // ===========================================================================

  const handleAddToCart = (id: RuleType["id"]) => {
    if (profile.personalVerification) {
      setLoading(true);
      TransactionPostCart(id, CartDetailTypeEnum.RULE)
        .then(({ data: res }) => {
          if (res.transaction_status) {
            Toast("success", res.message);
          } else {
            Toast("error", res.message);
          }
        })
        .finally(() => setLoading(false));
    } else {
      Toast("error", "لطفا ابتدا احراز هویت خود را انجام دهید");
    }
  };

  // ===========================================================================

  useEffect(() => {
    setLoading(true);
    TransactionRulesGet()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setRules(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // ===========================================================================

  return (
    <Fragment>
      <PageHeader src={setting.rule_banner} title="احکام" />
      <Empty
        data={rules}
        isLoading={loading}
        description="درحال حاضر حکمی وجود ندارد"
      >
        <div className="container mb-4">
          <div className="alert alert-warning text-justify" style={{lineHeight: 2}}>
            دریافت حکم کمربند هنرجویان هنر رزمی کوک سول وان داوطلبان گرامی احکام
            کمربند خواهشمند است به نکات ذیل توجه فرمایند:<br/> ۱. هزینه صدور احکام رده
            کمربندی را به حساب رئیس سبک ، استاد داود روستایی به شماره
            <strong className="cursor-pointer" onClick={() => handleCopyText("6274121168588192")}>
              {" "}
              6274121168588192{" "}
            </strong>{" "}
            واریز فرمایید ( در صورت بروز هرگونه مشکل مرتبط با شماره کارت،می توانید
            از شماره کارت موجود در صفحه تماس با ما استفاده کنید. )<br/> ۲. هزینه صدور
            احکام رده کمربندی طبق آخرین بروزرسانی در توضیحات هر کمربند درج شده
            است. ( این هزینه شامل هزینه صدور احکام طبق جدول اعلامی از سوی فدراسیون
            انجمن های ورزش های رزمی به اضافه هزینه های مرتبط با چاپ می باشد. )<br/>
            ۳. احکام فقط برای افرادی که مربی مربوطه اسامی آنان را ارسال نموده
            باشد صادر خواهد شد.<br/> ۴. کسانی که درخواست دریافت احکام چند کمربند اعم
            از کمربند فعلی و قبلی را دارند به صورت جداگانه هزینه هر حکم را واریز
            فرمایند.<br/> ۵. پس از واریز هزینه حکم حتما رسید تصویری آن را ذخیره کنید
            تا در مراحل بعد در بارگذاری رسید پرداختی مشکلی پیش نیاید.<br/> ۶. اطلاعات
            و تصویر حکم بصورت سیستمی در حکم درج میشود،پس بدیهی است هرگونه اشتباه
            توسط هنرجو در احراز هویت بوده.لازم به ذکر است حکم صادر شده ویرایش
            نخواهد شد و می‌بایست درخواست مجدد برای صدور حکم ثبت شود.
          </div>
          <div className="col-12">
            <div className="row g-3">
              {rules.map((rule) => (
                <div key={rule.id} className="col-sm-6 col-md-4">
                  <div className="card border p-3 h-100">
                    <div className="position-relative">
                      <div
                        className="position-relative z-index-9"
                        style={{ height: 200 }}
                      >
                        <img
                          className="card-img h-100 w-100 object-fit-contain"
                          src={rule.thumbnail}
                          alt={rule.title}
                        />
                      </div>
                    </div>

                    <div className="card-body text-center p-0 pt-3">
                      <h5 className="card-title">{rule.title}</h5>
                      <h6 className="mb-0 text-success">
                        {formatPrice(rule.price)} تومان
                      </h6>
                    </div>
                    {profile.personalVerification ? (
                      <div className="card-footer w-100 text-center p-0 pt-3">
                        <Button
                          onClick={() => handleAddToCart(rule.id)}
                          btnClass="w-100 btn-primary-soft mb-0"
                        >
                          <Fragment>
                            <i className="bi bi-cart me-2"></i>افزودن به سبد
                          </Fragment>
                        </Button>
                      </div>
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Empty>
    </Fragment>
  );
};

export default Rules;
